// Investiture
import React from 'react';
import { Hindicca1class2026 } from '../views';

const InvestiturePage = () => {
  return <Hindicca1class2026 />;
};

export default InvestiturePage;
